import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {CoreDI, Device, inject, Installer, ModuleIsEnabledFilter, ScreenOrientation} from '@gongxigames/framework/core';
import {createScrollToFullscreen, IScrollToFullscreen} from '@gongxigames/framework/slot';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class IOsFullscreenModule extends UIModuleV2 {
    public static NAME = 'IOsFullscreenModule';

    @inject(CoreDI.Device)
    protected _device!: Device;
    protected _scroll?: IScrollToFullscreen;

    public static readonly isEnabled: ModuleIsEnabledFilter = (components: Installer) => {
        const device = components.getComponent<Device>(CoreDI.Device);
        const {mobileSafari, fullscreen, isInIframe, iOS} = device;

        return iOS && (mobileSafari && !fullscreen) && !isInIframe;
    };

    onInit(): void {
        this._scroll = createScrollToFullscreen(this._device);
    }

    protected onSetupEvents(): void {
        super.onSetupEvents();

        this.emitter.on('UI.IOSScroll.Show', this.showScroll.bind(this));
        this.emitter.on('UI.IOSScroll.Hide', this.hideScroll.bind(this));
    }

    protected showScroll(): void {
        const orientation = this.getScreenOrientation();

        this._scroll?.show(orientation);
    }

    protected hideScroll(): void {
        const orientation = this.getScreenOrientation();

        this._scroll?.hide(orientation);
    }

    protected getScreenOrientation(): ScreenOrientation {
        return slotStore.stage_isPortrait.value ? ScreenOrientation.PORTRAIT : ScreenOrientation.LANDSCAPE;
    }

    public destroy(): void {
        super.destroy();

        this._scroll?.destroy();
    }
}